import React, {ChangeEvent, useEffect, useState} from "react";
import {FormControl, FormSelect} from "react-bootstrap";
import {post} from "../../utils/FetchUtil.ts";
import {getTodayInputDate} from "../../utils/CommonUtil.ts";

interface DeliveryDateTimeInputProps{
    title: string;
    orderLineDto?: OrderInputLineDto
    handleChange?: (date: string, timeCode: string) => void;
}

const DeliveryDateTimeInput: React.FC<DeliveryDateTimeInputProps> = ({
    title = "お届け希望日時",
    orderLineDto,
    handleChange
}) => {
    const [timeList, setTimeList] = useState<OptionDisplayDto[]>([]);
    useEffect(() => {
        post<OptionDisplayDto[]>({
            action: "/api/order/delivery/time_list",
            data: {delivery_company_id: orderLineDto?.delivery_company_id}
        })
            .then((data) => {
                if(data) {
                    setTimeList(data);
                }else {
                    setTimeList([]);
                }
            })
            .catch((reason) => {
                console.log(reason);
                setTimeList([]);
            })
            .finally(() => {});
    }, [orderLineDto?.delivery_company_id]);
    const onDateChange = (e: ChangeEvent<HTMLInputElement>)=> {
        console.log(e.target.value);
        if(handleChange){
            handleChange(e.target.value, orderLineDto?.delivery_request_time_code || "");
        }
    }
    const onTimeChange = (e: ChangeEvent<HTMLSelectElement>)=> {
        if(handleChange){
            handleChange(orderLineDto?.delivery_request_date_input || "", e.target.value);
        }
    }
    return(
      <dl className="delivery-request-datetime-input">
          <dt>{title}</dt>
          <dd>
              <FormControl
                  min={getTodayInputDate()}
                  type="date"
                  value={orderLineDto?.delivery_request_date_input || ""}
                  onChange={onDateChange}
                  onKeyDown={() => {return false}}
              />
              {orderLineDto && timeList.length !== 0 && (
                  <FormSelect
                      value={orderLineDto?.delivery_request_time_code || ""}
                      onChange={onTimeChange}
                  >
                      {timeList.map((dto) => (
                          <option key={dto.value}
                                  value={dto.value}
                          >
                              {dto.title}
                          </option>
                      ))}
                  </FormSelect>
              )}
          </dd>
      </dl>
    );
};
export default DeliveryDateTimeInput;